export const formatDate = (dateString: string) => {
  if (!dateString) {
    return ''
  }

  const format = (d: Date) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })

  // Fast path (only for ISO-like strings to avoid ambiguous locale parsing)
  const isIsoLike = /^\d{4}-\d{2}-\d{2}(?:[T\s].*)?$/
  if (isIsoLike.test(dateString)) {
    const native = new Date(dateString)
    if (!isNaN(native.getTime())) {
      return format(native)
    }
  }

  // Fallback: parse delimited numeric formats
  const nums = (dateString.match(/\d+/g) || []).map(Number)
  if (nums.length < 3) {
    return 'Invalid Date'
  }

  let year = 0
  let month = 0
  let day = 0

  if (String(nums[0]).length === 4) {
    // yyyy-mm-dd or yyyy/mm/dd
    ;[year, month, day] = [nums[0], nums[1], nums[2]]
  } else if (String(nums[2]).length === 4) {
    // dd-mm-yyyy or mm-dd-yyyy
    year = nums[2]
    const a = nums[0]
    const b = nums[1]
    if (a > 12 && b <= 31) {
      day = a
      month = b
    } else if (b > 12 && a <= 12) {
      month = a
      day = b
    } else {
      // Ambiguous: default to dd-mm-yyyy
      day = a
      month = b
    }
  } else {
    return 'Invalid Date'
  }

  const parsed = new Date(year, month - 1, day)
  if (isNaN(parsed.getTime())) {
    return 'Invalid Date'
  }

  return format(parsed)
}
